import type { ReactNode } from 'react'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { RECAPTCHA } from '@core/utils/constants/constants'
import i18n from '@core/utils/i18n'

interface RecaptchaProviderProps {
    children: ReactNode
}

export const RecaptchaProvider = ({ children }: RecaptchaProviderProps) => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={RECAPTCHA}
            useEnterprise={true}
            language={i18n.language}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'head',
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    )
}
